/*
 * @Author: 张帮辉
 * @LastEditors: 彭鑫诚
 * @Date: 2022-03-03 14:22:38
 * @LastEditTime: 2024-07-17 11:58:29
 * @Description: file content
 */

import { getToday } from '@monorepo/utils';
import type {
  ITransferInOrderModel,
  ITransferInOrderStore,
} from '@monorepo/types/orders/transferInOrder/transferInOrder.types';
import { tableUpdate } from '@monorepo/utils';

const initState: ITransferInOrderStore = {
  query: {
    page: 1,
    pageSize: 50,
    date_type: 'CREATED_DATE',
    sort_order: 'CREATED_DESC',
    date: getToday(),
    order_state: '',
  },
  isInit: true,
  auditNo: '',
  tableList: [],
  total: 0,
  total_money: '0',
  total_use_unit_qty: '0',
};

const transferInOrderStore: ITransferInOrderModel = {
  namespace: 'transferInOrderStore',
  state: initState,
  reducers: {
    save(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
    updateTableList(state, { payload }) {
      const tableList = tableUpdate(state.tableList, payload.data, payload.auditNo);
      return {
        ...state,
        tableList,
      };
    },
    resetInit() {
      return { ...initState };
    },
  },
};

export default transferInOrderStore;
